module.exports = __webpack_public_path__ + "static/media/photo293.27ac37fc.jpg";